import React from "react";
import { defaultDropList } from "components/WebDesigner/Data/WBComponentDefaults";
import { WBComponent } from "./WBComponent";
import { WBRenderProps } from "vagaro-website-rendering/src/components/Definitions/WBRenderProps";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import LayoutNode, { getNodeComponentAttributeValue, setNodeComponentAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { AttributeDefinition, AttributeInputType } from "../Data/WBData";
import WebDesigner from "../WebDesigner";
import CreateAttributeList, { componentAttributeTypes } from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import { GetLocationHoverAtt, GetNodeDomAttributes } from "vagaro-website-rendering/src/components/Utilities/GetNodeDomAttributes";
import { GenericBusinessControl } from "vagaro-website-rendering/src/components/Binding/GenericBusinessControl";
import BusinessPlaceHolder from "./BusinessDataRendering/BusinessPlaceHolder";

export default class BusinessHours extends WBComponent {
    constructor() {
        super();
        this.vagaroLink = "https://www.vagaro.com/business/businessprofile";
        this.typename = wBComponentTypeNames.businessHours;
        this.displayName = "Hours";
        this.dropList = defaultDropList;
        this.editList = [componentAttributeTypes.multiLocation, ...CreateAttributeList(true, true, true, true, true,false,false), "stripeColor"];
        this.contentEditable = false;
        this.primaryEditAttributes = [componentAttributeTypes.multiLocation]
        this.icon = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor">
            <path d="M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z" /></svg>


    }

    onFirstTimeCreation(newParent: LayoutNode, thisLayout: LayoutNode, manager: WebDesigner): void {
        setNodeComponentAttributeValue(thisLayout, componentAttributeTypes.multiLocation, manager.props.siteData.userContext.businessId);
    }

    getComponentSpecificAttributeDefinitions(): AttributeDefinition[] {
        return [new AttributeDefinition("stripeColor", "Stripe Color", "", AttributeInputType.ColorField)];
    }

    RenderLayout({ component, screenSize, userContext: siteData, isEditor }: WBRenderProps) {

        const atts = GetNodeDomAttributes("v-business-hours max-w-100  clamp-height vp-2 vb-control relative", component, screenSize, isEditor);
        const bid = getNodeComponentAttributeValue(component, componentAttributeTypes.multiLocation, siteData.businessId);
        if (!isEditor)
            return <BusinessPlaceHolder node={component} dataKey={"hours"} layout={'1'} classNames={atts.className} />

        return (
            <div {...atts} {...GetLocationHoverAtt(component,siteData)}>
                <GenericBusinessControl key={component.id + bid} layout={"1"} dataKey={"hours"} node={component} userContext={siteData} bLocationId={bid} />
            </div>
        )
    }

}





// const leftStyle: {} = { textAlign: "left", padding: "0px 10px" };

// function MapHour({ day, index, stripeColor }: { day: { weekDay: string, openTime: string, closeTime: string, isOpen: boolean }, index: number, stripeColor: string }) {

//     let openTime = getTimeString(day.openTime);
//     let closeTime = getTimeString(day.closeTime);

//     const style = index % 2 == 0 ? leftStyle : { ...leftStyle, backgroundColor: stripeColor };

//     return (
//         <tr style={style} >
//             <td ><strong>{day.weekDay}</strong></td>
//             {day.isOpen ?
//                 <>
//                     <td>{openTime}</td>
//                     <td>-</td>
//                     <td>{closeTime}</td>
//                 </>
//                 :
//                 <><td colSpan={2}></td>
//                     <td>Closed</td>
//                 </>
//             }


//         </tr>
//     )
// }

// function getTimeString(inString: string) {

//     let newTime = inString.substring(0, 5);

//     let hour = parseInt(newTime.substring(0, 2));

//     let mins = newTime.substring(3, 5);

//     let ampm = "AM";

//     if (hour > 12) {
//         hour = hour - 12;
//         ampm = "PM";
//     }
//     if (hour == 0)
//         hour = 12;

//     return hour + ":" + mins + " " + ampm;



// }

